import Vue from 'vue';
import { toast, modal, Cell, CellLeft, CellRight, Button, ButtonLine, ScrollView, Bill, Nav } from '@mx/vix';
import './customDirective';

[Cell, CellLeft, CellRight, Button, ButtonLine, ScrollView, Bill, Nav].map((c) => Vue.use(c));

Vue.prototype.$toast = toast;
Vue.prototype.$modal = modal;

export * from './env';
export * from './ajax';
export * from './analytics';
export * from './bridge';
export * from './util';
export * from './request';
export * from '../config/analyticConfig';
export * from '../config/assetsConfig';
export * from './monitor';
export * from './enum';
export * from './constant';
export * from './envRuntime';
